// import { useState } from 'react';
import { Badge, Skeleton } from 'antd';
// import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import 'moment/dist/locale/bn';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { usePostSeenNotificationMutation } from './store/notificationSlice';
import Icons from '../../../configs/icon.config';
import { Translate } from '../index';
import {
  commonState,
  setMobileMenuDrawerClose,
  setShowNav,
  setShowSearchNav,
} from '../../../app/base/commonSlice';
import { openDialog } from '../Large-footer/Large-footer-top/store/stateSlice';
import { setFeedbackDrawerOpen } from '../Feedback/store/stateSlice';

interface NotificationListProps {
  data: any;
  maxHeight?: string | number;
  hasMore: any;
  fetchNextPage: () => void;
  isLoading: boolean;
}

function NotificationList({
  data,
  maxHeight,
  fetchNextPage,
  hasMore,
  isLoading,
}: NotificationListProps) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { language } = useSelector(commonState);
  const [postSeenNotification] = usePostSeenNotificationMutation();
  const navigate = useNavigate();

  const closeMobileNotificationDrawer = () => {
    dispatch(
      setMobileMenuDrawerClose({
        isDrawerOpen: false,
        menuKey: 'isMobileNotificationClose',
      })
    );
  };

  const handleClicked = async (
    id: number | string,
    url: string,
    action: string
  ) => {
    try {
      await postSeenNotification(id);
    } catch (err) {
      console.log(err);
    }

    if (action === 'URL') {
      const isExternal =
        url.startsWith('http://') || url.startsWith('https://');

      if (isExternal) {
        window.open(url, '_blank');
      } else if (url === '/admin/notification-list') {
        navigate(url, { state: true });
      } else {
        navigate(url);
      }
    } else if (action === 'IMPORTANT_CONTACT') {
      dispatch(openDialog());
      closeMobileNotificationDrawer();
    } else if (action === 'FEEDBACK' && !isMobile) {
      dispatch(setFeedbackDrawerOpen(true));
      closeMobileNotificationDrawer();
    } else if (action === 'SEARCH') {
      dispatch(setShowSearchNav(true));
      dispatch(setShowNav(false));
      closeMobileNotificationDrawer();
    }
  };

  // console.log(data);

  return (
    <>
      <div
        style={{
          maxHeight: `${maxHeight}px`,
          overflowY: 'auto',
        }}
      >
        <InfiniteScroll
          next={() => fetchNextPage()}
          dataLength={data.length}
          hasMore={hasMore}
          height={Number(maxHeight)}
          loader={
            <div>
              <div className="my-2">
                <Skeleton active style={{ width: '100%' }} />
              </div>
            </div>
          }
          endMessage={
            <p
              className="text-pink-500 underline font-light border-t"
              style={{ textAlign: 'center' }}
            >
              <Translate en="End of notifications" bn="নোটিফিকেশন শেষ" />
            </p>
          }
        >
          {isLoading ? (
            <Skeleton
              active
              style={{ width: '100%' }}
              paragraph={{ rows: 4 }}
            />
          ) : (
            data.map((item: any, index: any) => (
              <button
                className={classNames(
                  `flex items-start gap-7 min-h-[85px] px-10 py-2 w-full ${
                    item.is_clicked
                      ? 'bg-white dark:bg-[#181818FF]'
                      : 'bg-[#F6F6F6] dark:bg-[#313131]'
                  } dark:border-[#565657]`,
                  {
                    'border-b': data?.length !== index + 1,
                  }
                )}
                key={item?.id}
                onClick={() => handleClicked(item?.id, item?.url, item?.action)}
              >
                <div>
                  {!item.is_clicked ? (
                    <Badge color="#D10D74" status="processing" />
                  ) : (
                    <Badge color="black" />
                  )}
                </div>
                <div className="w-[360px] text-left">
                  <div className="min-h-[50px]">
                    <Translate en={item.message_en} bn={item.message_bn} />
                  </div>
                  <div className="text-[#9E9E9E]">
                    {moment
                      .utc(item.created_at)
                      .locale(language)
                      .local()
                      .fromNow()}
                  </div>
                </div>
              </button>
            ))
          )}
        </InfiniteScroll>
      </div>
      <h1 className="flex items-center gap-2 justify-center p-2 text-[14px] text-[#D10D74] font-medium border-t-2 dark:border-[#565657]">
        {data.length >= 4 ? (
          <button className="flex items-center justify-center gap-2 cursor-default">
            <span className="underline scroll-more-button">
              <Translate en="Scroll to see more" bn="আরও দেখতে স্ক্রল করুন" />
            </span>{' '}
            <span className="animate-bounce">{Icons.doubleDown}</span>
          </button>
        ) : null}
      </h1>
    </>
  );
}

export default memo(NotificationList);
